import secure_axios from "../../services/secure_axios";
const initialState = () =>({
  allorders: [],
  orderitems:[],
  thisorder:{},
  ordertypes:['SO','DO','SI','SR'],
  thisordertype:"",
  currencytypes:[],
  thiscurrencytype:"",
});

const state = initialState();

const getters = {
  allorders: (state) => state.allorders,
  orderitems: (state) => state.orderitems,
  thisorder: (state) => state.thisorder,
  ordertypes: (state) => state.ordertypes,
  thisordertype: (state) => state.thisordertype,
  currencytypes:(state) => state.currencytypes,
  thiscurrencytype:(state) => state.thiscurrencytype,  
};

const mutations = {
  setallorders(state, payload) {
    state.allorders = payload;
  },
  setorderitems(state, payload) {
    state.orderitems = payload;
  },
  setthisorder(state,payload) {
    state.thisorder = payload
  },
  clearorderitems(state) {
    state.orderitems = [];
  },
  setordertypes(state,payload){
    state.ordertypes = payload
  },
  setthisordertype(state,payload){
    state.ordertype = payload
  },
  setcurrencytypes(state,payload){
    state.currencytypes = payload
  },
  setthiscurrencytype(state,payload){
    state.thiscurrencytype = payload
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getallorders({ commit,getters }, payload) {      
    commit("setLoading", true); 
    commit("clearError");  

    const smandocno = payload.smandocno;
    const sodoctype = payload.sodoctype;
    secure_axios
      .get(`${getters.sessionAPI}orders?smandocno=${smandocno}&sodoctype=${sodoctype}`)
      .then((response) => {          
        commit("setallorders", response.data.salesorder);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },
  getorderitems({ commit,getters }, payload) {      
    commit("setLoading", true); 
    commit("clearError");

    const saldet_docno = payload.saldet_docno;      
    secure_axios
      .get(`${getters.sessionAPI}orderitems?saldet_docno=${saldet_docno}`)
      .then((response) => {          
        commit("setorderitems", response.data.orderitems);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },
  clearorderitems({ commit }) {
    commit("clearorderitems");
  },  
  thisorder({ commit }, payload) {
    commit("setthisorder", payload);
  },
  ordertype({commit},payload){
    commit("setordertype",payload);
  },
  // getordertypes({commit,getters},payload){
  //   commit("setLoading", true); 
  //   commit("clearError"); 
    
  //   // const customer = payload.customer;
  //   secure_axios
  //   .get(`${getters.sessionAPI}`)
  // }

};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
